import { devtools } from 'zustand/middleware';
import { createStore, StateCreator } from 'zustand/vanilla';

const likeStatusCreator: StateCreator<
  Record<string, boolean | null>,
  [],
  [],
  Record<string, boolean | null>
> = () => ({});
export const likeStatusStore = createStore(devtools(likeStatusCreator, { name: 'likeStatusStore' }));

export type LikeMeta = Record<
  string,
  {
    has: boolean;
    inView: boolean;
    order: number;
    groupOrder: number;
    id: string;
    shouldSkipApiCall?: boolean; // API 호출을 건너뛸지 여부
    wasInitializedWithSavedProduct?: boolean; // is_saved_product로 초기화되었는지 여부
  }
>;

const likeMetaCreator: StateCreator<LikeMeta, [], [], LikeMeta> = () => ({});
export const likeMetaStore = createStore(devtools(likeMetaCreator, { name: 'checkIdsStore' }));
